import React from 'react'
import { Button, Flex, Box } from 'system'

export const ToggleButton = ({ toggle, on, ...props }) => (
  <Flex
    as={Button}
    width="50px"
    height="30px"
    bg={on ? '#4FD1C5' : 'white'}
    borderRadius="60px"
    border="1px solid"
    onClick={toggle}
    transitionProperty="background, border-color"
    transitionTimingFunction="cubic-bezier(0.24, 0, 0.5, 1)"
    boxShadow="inset 0 2px 4px 0 rgba(0, 0, 0, 0.1);"
    outline="none"
    borderColor={on ? '#4FD1C5' : 'white'}
    css={{
      userSelect: 'none',
    }}
    {...props}
  >
    <Box
      bg="whitesmoke"
      boxShadow="0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 0px 0 hsla(0, 0%, 0%, 0.04), 0 4px 9px hsla(0, 0%, 0%, 0.13), 0 3px 3px hsla(0, 0%, 0%, 0.05)"
      height="28px"
      borderRadius="60px"
      width="28px"
      position="relative"
      transform={on ? 'translateX(23px)' : 'translateX(0px)'}
      transitionProperty="transform"
      transitionTimingFunction="cubic-bezier(0.54, 1.6, 0.5, 1)"
      transitionDuration=".35s"
    />
  </Flex>
)
